import request from '@/utils/request'

/**
 * 设备默认参数管理API
 */

/**
 * 根据设备类型和子类型获取默认参数
 * @param {string} deviceType 设备类型
 * @param {string} deviceSubtype 设备子类型（可选）
 * @returns {Promise<{code: number, message: string, data: {id: number, deviceType: string, deviceSubtype: string, defaultParams: string, description: string, createTime: string, updateTime: string, isDeleted: boolean}}>} 默认参数配置信息
 */
export function getByDeviceTypeAndSubtype(deviceType, deviceSubtype = null) {
  const params = { deviceType }
  if (deviceSubtype) {
    params.deviceSubtype = deviceSubtype
  }
  
  return request({
    url: '/device-default-params/by-type-subtype',
    method: 'get',
    params
  })
}

/**
 * 根据设备类型获取默认参数列表
 * @param {string} deviceType 设备类型
 * @returns {Promise<{code: number, message: string, data: Array<{id: number, deviceType: string, deviceSubtype: string, defaultParams: string, description: string, createTime: string, updateTime: string, isDeleted: boolean}>}>} 默认参数配置列表
 */
export function getByDeviceType(deviceType) {
  return request({
    url: `/device-default-params/by-type/${deviceType}`,
    method: 'get'
  })
}

/**
 * 获取所有设备类型
 * @returns {Promise<{code: number, message: string, data: Array<string>}>} 设备类型列表
 */
export function getAllDeviceTypes() {
  return request({
    url: '/device-default-params/device-types',
    method: 'get'
  })
}

/**
 * 根据设备类型获取子类型列表
 * @param {string} deviceType 设备类型
 * @returns {Promise<{code: number, message: string, data: Array<string>}>} 子类型列表
 */
export function getSubtypesByDeviceType(deviceType) {
  return request({
    url: `/device-default-params/subtypes/${deviceType}`,
    method: 'get'
  })
}

/**
 * 保存设备默认参数
 * @param {Object} data 设备默认参数数据
 * @param {string} data.deviceType 设备类型
 * @param {string} data.deviceSubtype 设备子类型
 * @param {string} data.defaultParams 默认参数配置，JSON格式
 * @param {string} data.description 参数描述说明
 * @returns {Promise<{code: number, message: string, data: string}>} 保存结果
 */
export function save(data) {
  return request({
    url: '/device-default-params',
    method: 'post',
    data
  })
}

/**
 * 根据ID获取设备默认参数
 * @param {number} id 参数ID
 * @returns {Promise<{code: number, message: string, data: {id: number, deviceType: string, deviceSubtype: string, defaultParams: string, description: string, createTime: string, updateTime: string, isDeleted: boolean}}>} 默认参数配置信息
 */
export function getById(id) {
  return request({
    url: `/device-default-params/${id}`,
    method: 'get'
  })
}

/**
 * 根据ID更新设备默认参数
 * @param {number} id 参数ID
 * @param {Object} data 设备默认参数数据
 * @returns {Promise<{code: number, message: string, data: string}>} 更新结果
 */
export function updateById(id, data) {
  return request({
    url: `/device-default-params/${id}`,
    method: 'put',
    data
  })
}

/**
 * 根据ID删除设备默认参数
 * @param {number} id 参数ID
 * @returns {Promise<{code: number, message: string, data: string}>} 删除结果
 */
export function deleteById(id) {
  return request({
    url: `/device-default-params/${id}`,
    method: 'delete'
  })
}

/**
 * 分页查询设备默认参数列表
 * @param {number} pageNum 页码
 * @param {number} pageSize 每页大小
 * @returns {Promise<{code: number, message: string, data: Array<{id: number, deviceType: string, deviceSubtype: string, defaultParams: string, description: string, createTime: string, updateTime: string, isDeleted: boolean}>}>} 分页数据
 */
export function list(pageNum = 1, pageSize = 10) {
  return request({
    url: '/device-default-params/list',
    method: 'get',
    params: { pageNum, pageSize }
  })
}

export default {
  getByDeviceTypeAndSubtype,
  getByDeviceType,
  getAllDeviceTypes,
  getSubtypesByDeviceType,
  save,
  getById,
  updateById,
  deleteById,
  list
}
